import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="dark bg-sidebar text-sidebar-foreground py-16 border-t border-sidebar-border">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          {}
          <div className="flex flex-col items-start space-y-6">
            <img src="https://notable-crane.10web.cloud/wp-content/uploads/2026/02/cropped-Bild-12.02.26-um-17.20.jpeg" alt="Leci Bau GmbH & Co.KG" className="object-contain !h-[97px] !w-[60px]" />
            <p className="text-sidebar-foreground/80 text-sm leading-relaxed max-w-xs font-sans">Ihr verlässlicher Partner für präzise Rohbauarbeiten und solide Grundstrukturen in Hamburg und Umgebung.</p>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-sidebar-primary font-mono">
              Quick Links
            </h3>
            <nav className="flex flex-col space-y-3">
              <Link to="/HomePage" className="text-sidebar-foreground/70 hover:text-sidebar-primary transition-colors text-sm font-medium w-fit">
                Home
              </Link>
              <Link to="#" className="text-sidebar-foreground/70 hover:text-sidebar-primary transition-colors text-sm font-medium w-fit">
                Leistungen
              </Link>
              <Link to="#" className="text-sidebar-foreground/70 hover:text-sidebar-primary transition-colors text-sm font-medium w-fit">
                Kontakt
              </Link>
            </nav>
          </div>

          {}
          <div className="flex flex-col space-y-6">
            <h3 className="text-sm font-semibold uppercase tracking-wider text-sidebar-primary font-mono">
              Rechtliches
            </h3>
            <nav className="flex flex-col space-y-3">
              <Link to="#" className="text-sidebar-foreground/70 hover:text-sidebar-primary transition-colors text-sm font-medium w-fit">
                Impressum
              </Link>
              <Link to="#" className="text-sidebar-foreground/70 hover:text-sidebar-primary transition-colors text-sm font-medium w-fit">
                Datenschutz
              </Link>
            </nav>
          </div>
        </div>

        <Separator className="bg-sidebar-border mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-sidebar-foreground/50 font-mono">
          <p>© 2019 Leci Baustahl GmbH &amp; Co.KG. Alle Rechte vorbehalten.</p>
          <p>Qualität. Sicherheit. Transparenz.</p>
        </div>
      </div>
    </footer>;
}